import './App.css';
import 'swiper/swiper-bundle.css';
import 'react-datepicker/dist/react-datepicker.css';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {Layout} from "./components/layout/Layout";
import {HomePage} from "./pages/HomePage";
import {MenuPage} from "./pages/MenuPage";
import {ContactPage} from "./pages/ContactPage";
import ScrollToTop from "./components/layout/ScrollTop";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import {BranchProvider, useBranch} from "./context/BranchContext";
import BranchSelector from "./components/BranchSelector";

const MainRoutes = () =>{
    const { branch } = useBranch();

    // QUAN TRỌNG: Nếu chưa chọn branch → chỉ hiện màn hình chọn
    if (!branch) {
        return <BranchSelector />;
    }

    return   <Routes>
        <Route path="/" element={<Layout><HomePage/></Layout>}/>
        <Route path="/speisekarte" element={<Layout><MenuPage/></Layout>}/>
        <Route path="/kontaktieren-sie-uns" element={<Layout><ContactPage/></Layout>}/>
        <Route path="/impressum" element={<Layout><Impressum/></Layout>}/>
        <Route path="/datenschutz" element={<Layout><Datenschutz/></Layout>}/>
    </Routes>
}
function App() {
    return (
        <BrowserRouter>
            <BranchProvider>
            <ScrollToTop>
                <MainRoutes/>
            </ScrollToTop>
            </BranchProvider>
        </BrowserRouter>
    );
}

export default App;
